import React, { useContext } from 'react';
import DocumentUploadContext from '../../context/DocumentUpload/documentUploadContext';
import SchedulerMain from '../../pages/SchedulerMain';
import ActivateCardMain from '../../pages/ActivateCardMain';
import ChangePinMain from '../../pages/ChangePinMain';
import Upload from '../../pages/Upload';
import SelectSchedule from '../../pages/SelectSchedule';
import Acknowledgement from '../../pages/Acknowledgement';
import NoticePage from '../../pages/NoticePage';
import SelectScheduleSummary from '../../pages/SelectScheduleSummary';
import SchedulerAcknowledgement from '../../pages/SchedulerAcknowledgement';
import ActivateCardNominatePin from '../../pages/ActivateCardNominatePin';
import ChangePinNominatePin from '../../pages/ChangePinNominatePin';
import ChangePinMobileNumber from '../../pages/ChangePinMobileNumber';
import ActivateCardAcknowledgement from '../../pages/ActivateCardAcknowledgement';
import ChangePinAcknowledgement from '../../pages/ChangePinAcknowledgement';

const ChangePinForm = () => {
  const documentUploadContext = useContext(DocumentUploadContext);
  const currentURL = window.location.href;
  switch (documentUploadContext.step) {
    case 0:
      return <ChangePinMain />;
    case 1:
      return currentURL.includes("Scheduler") ? <SelectSchedule /> : <Upload /> ;
    case 2:
      return <Acknowledgement />;
    case 3:
      return <NoticePage />;
    case 4:
      return <SelectScheduleSummary />;
    case 5:
      return <SchedulerAcknowledgement />;
    case 6:
      return <ChangePinNominatePin />;
    case 7:
      return <ChangePinAcknowledgement />;
    case 8:
      return <ChangePinMobileNumber />;
    default:
      return <h1>{''}</h1>;
  }
};
export default ChangePinForm;
